import { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

function PemegangSaham() {
    const [visibleADP, setVisibleADP] = useState(false);
    const [visibleAAW, setVisibleAAW] = useState(false);

    return (
        <>
            <div className="pemegang-saham">
                <div className="container-pemegang-saham">
                    <h1>Pemegang Saham</h1>
                    <div className="container-card">

                        {/* PT. ADIWISISTA DAYA PRATAMA */}
                        <div
                            className="card adp hover cursor-pointer"
                            onClick={() => setVisibleADP(true)}
                        >
                            <p className="company">PT. Adiwisista Daya Pratama</p>
                            <p className="percentage">90%</p>
                        </div>

                        <Dialog
                            visible={visibleADP}
                            className="pemegang-saham adp"
                            modal
                            onHide={() => setVisibleADP(false)}
                            footer={
                                <Button
                                    label="Tutup"
                                    icon="pi pi-times"
                                    onClick={() => setVisibleADP(false)}
                                    className="p-button-text"
                                />
                            }
                        >
                            <h4 style={{textAlign: "center"}}>PT. Adiwisista Daya Pratama</h4>
                            <p style={{textAlign: "center"}}>
                                Perusahaan induk Danai.id yang berfokus pada inovasi layanan 
                                pendanaan berbasis teknologi dan kolaborasi strategis internasional.
                            </p>
                        </Dialog>

                        {/* PT. ANUGRAH ADITAMA WISISTA */}
                        <div
                            className="card aaw hover cursor-pointer"
                            onClick={() => setVisibleAAW(true)}
                        >
                            <p className="company">PT. Anugrah Aditama Wisista</p>
                            <p className="percentage">10%</p>
                        </div>

                        <Dialog
                            visible={visibleAAW}
                            className="pemegang-saham aaw"
                            modal
                            onHide={() => setVisibleAAW(false)}
                            footer={
                                <Button
                                    label="Tutup"
                                    icon="pi pi-times"
                                    onClick={() => setVisibleAAW(false)}
                                    className="p-button-text"
                                />
                            }
                        >
                            <h4 style={{textAlign: "center"}}>PT. Anugrah Aditama Wisista</h4>
                            <p style={{textAlign: "center"}}>
                                Perusahaan terdaftar di Indonesia yang berlokasi di SCBD, 
                                Jakarta Selatan, dan mendukung pengembangan dan strategi bisnis Perseroan.
                            </p>
                        </Dialog>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PemegangSaham;
